/** Shared merchant-facing copy for Redo fulfillment group tag pickers (not i18n yet). */
export const fulfillmentGroupCreateTagLabel = "Create new tag";

export const fulfillmentGroupTagSearchPlaceholder =
  "Search Redo fulfillment tags";
